import React from 'react';
import PropTypes from 'prop-types';

import { PreviewCondition } from '@ubisend/pulse-components';
import { ConditionPreview } from '@ubisend/pulse-conditionals';

const SectionPreview = ({ prefix = 'When', ...props }) => (
  <p>
    {prefix} imported content
    <PreviewCondition>{props.type.name}</PreviewCondition>
    <ConditionPreview {...props} />
  </p>
);

SectionPreview.propTypes = {
  prefix: PropTypes.string,
  subject: PropTypes.shape({
    target: PropTypes.string
  }),
  flipped: PropTypes.number,
  type: PropTypes.shape({ type: PropTypes.string, name: PropTypes.string })
};

export default SectionPreview;
